import { Box, Grid } from '@mui/material';
import { Outlet } from 'react-router-dom';
import { Navbar, SideBar } from '../Navbar';
// import { Footer } from '../Footer';
import { useOrganizations } from '../../customHooks';
import { useEffect, useState } from 'react';

export const Layout = () => {
  const { organizationSideBar } = useOrganizations();
  const [openSidebar, setOpenSidebar] = useState(true);

  useEffect(() => {
    if (organizationSideBar) {
      setOpenSidebar(true);
    }
  }, [organizationSideBar]);

  const handleSidebarOpen = () => {
    setOpenSidebar((prev) => !prev);
  };
  return (
    <Grid container sx={{ height: '100%' }}>
      {organizationSideBar && (
        <Grid
          item
          sx={{
            width: openSidebar ? '25rem' : '0rem',
            background: 'linear-gradient(to right, #b2e4ed, #a0d3e8)',
            borderRight: '1px solid',
            borderColor: 'grey.300',
            height: '100%',
            overflow: 'auto',
            transition: 'width 0.3s ease-in-out'
          }}
        >
          <SideBar
            organizationSideBar={organizationSideBar}
            openSidebar={openSidebar}
            setOpenSidebar={setOpenSidebar}
          />
        </Grid>
      )}
      <Grid item flex={1} sx={{ height: '100%', overflow: 'auto', display: 'flex', flexDirection: 'column' }}>
        <Navbar showSideBarOption={!!organizationSideBar} handleSidebarOpen={handleSidebarOpen} />
        <Box
          sx={{
            flex: 1,
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'space-between'
          }}
        >
          <Outlet />
          {/* <Footer /> */}
        </Box>
      </Grid>
    </Grid>
  );
};
